import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { AbUsuarioConta } from "app/abstract/full-pages/meus-dados/usuario-conta.abstract";

@Injectable({ providedIn: 'root' })
export class UsuarioContaService extends AbUsuarioConta {

  constructor(http: HttpClient) {
    super(http);
  }

  public enviarEmailConfirmarExlusao() {
    return this.get("public/usuariocontas/emailconfirmarinativacao/");
  }
}
